import { DataDictionary } from './DataDictionary';
import { getDataDictionarySelector } from './@arch/selectors';
import React from 'react';
import { ViewArea } from '@ui/general';

import { useAsyncState, useTags, useUsers } from '@hooks';

export const DataDictionaryView: React.FC = () => {
	const { isRequested, isReceived } = useAsyncState(getDataDictionarySelector);

	useTags(true);
	useUsers(true);

	return (
		<ViewArea
			collapseSidebar
			direction={ isRequested || isReceived ? 'horizontal' : 'vertical' }
			fullWidth
			id='data-dictionary-view'
			showPeriscopes={ 1 }>
			<DataDictionary />
		</ViewArea>
	);
};
